import { api } from 'data/api/api'
import { Screen } from 'constants/tracking/screens'

import { GetPluginsByFeatureArgs, PluginsByFeatureResponse } from '../types/get-plugins-by-feature'
import {
  GetItemsByPluginNameArgs,
  GetItemsByNameArgs,
  ItemsByPluginNameResponse,
  ItemsByNameResponse,
} from '../types/items-block'

export const getPluginsByFeature = ({ itemId, feature, params }: GetPluginsByFeatureArgs) =>
  api.get<PluginsByFeatureResponse>(`/items/${itemId}/plugins/${feature}`, { params })

export const getItemsByPluginName = ({ itemId, name }: GetItemsByPluginNameArgs) =>
  api.get<ItemsByPluginNameResponse>(`/items/${itemId}/plugins/items`, {
    params: { name },
  })

export const getItemsByName = ({ itemId, name }: GetItemsByNameArgs) =>
  api.get<ItemsByNameResponse>(`/items/${itemId}/more`, {
    params: { content_source: name, screen: Screen.Item },
  })
